<template>
  <div class="form-group with-icon-right dropdown select-form-group multiselect-form-group"
       v-dropdown="{noToggle: search, prevent: !search, disabled: readonly}"
       :class="{'has-error': hasErrors()}"
       ref="dropdownContainer"
       @dropdownToggle="show => show ? inputValue = '' : updateDisplayValue(_value)">
    <div class="input-group dropdown-toggle">
      <input
        :placeholder="placeholder"
        :readonly="readonly || !search"
        :class="{'has-value': !!inputValue, 'no-value': !inputValue, search, 'read-write': !readonly}"
        v-model="inputValue"
        :name="name"
      />
      <i class="ion ion-ios-arrow-down icon-right input-icon" v-if="!readonly"></i>
      <label class="control-label">{{label}}</label><i class="bar"></i>
      <small v-show="hasErrors()" class="help text-danger">{{ showRequiredError() }}</small>
    </div>
    <slot name="icon"></slot>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <scrollbar ref="scrollbar">
        <div class="dropdown-menu-content">
          <div class="dropdown-item"
               :class="{'selected': isOptionSelected(option)}" v-for="option in options"
               @click="toggleSelection(option)">
            <slot :value="option"><span class="ellipsis">{{renderOptionDisplay(option)}}</span></slot>
          </div>
        </div>
      </scrollbar>
    </div>
  </div>
</template>

<script>
  import Dropdown from 'vuestic-directives/Dropdown';
  import Scrollbar from '../vuestic-scrollbar/VuesticScrollbar.vue';

  export default {
    name: 'vuestic-multi-select',
    components: {
      Scrollbar,
    },
    directives: {
      dropdown: Dropdown,
    },
    data () {
      return {
        inputValue: '',
        validated: false,
      };
    },
    props: {
      label: String,
      options: Array,
      value: Array,
      optionKey: String,
      required: {
        type: Boolean,
        default: false,
      },
      name: {
        type: String,
        default: 'multiselect',
      },
      search: Boolean,
      displayValue: Function,
      placeholder: String,
      maxDisplayItems: {
        type: Number,
        default: 3,
      },
      readonly: Boolean,
    },
    computed: {
      _value () {
        return Array.isArray(this.value)
          ? this.value
          : this.value
            ? [this.value]
            : [];
      },
    },
    mounted () {
      this.updateDisplayValue(this._value);
      // this.$emit('input', this._value);
    },

    // updated: function () {
    //   this.updateDisplayValue(this._value)
    // },

    watch: {
      inputValue () {
        if (this.$refs.dropdownContainer && this.$refs.dropdownContainer.classList.contains('show')) {
          this.$emit('search', this.inputValue);
        }
      },
      value (v) {
        this.updateDisplayValue(v);
      },
      options () {
        setTimeout(() => {
          this.$refs.scrollbar && this.$refs.scrollbar.onContentResize();
        });
      },
    },

    methods: {
      toggleSelection (option) {
        let newVal = this.isOptionSelected(option) ? this.deselectOption(option) : this.selectOption(option);
        this.updateDisplayValue(newVal);
        this.$emit('input', newVal);
      },
      isOptionSelected (option) {
        return this._value.includes(option);
      },
      selectOption (option) {
        return this._value.concat(option);
      },
      deselectOption (option) {
        return this._value.filter(item => item !== option);
      },
      updateDisplayValue (newVal) {
        if (this.search && this.$refs.dropdownContainer && this.$refs.dropdownContainer.classList.contains('show')) {
          return;
        }
        if (newVal.length > this.maxDisplayItems) {
          this.inputValue = `${newVal.length} of ${this.options.length} chosen`;
        } else {
          this.inputValue = newVal.map(this.renderOptionDisplay).join(', ');
        }
      },
      renderOptionDisplay (val) {
        return this.displayValue
          ? this.displayValue(val)
          : val == null
            ? ''
            : this.optionKey
              ? val[this.optionKey]
              : val;
      },
      validate () {
        this.validated = true;
      },
      isValid () {
        let isValid = true;
        if (this.required) {
          isValid = !!this.displayValue;
        }
        return isValid;
      },
      hasErrors () {
        let hasErrors = false;
        if (this.required) {
          hasErrors = this.validated && !this.displayValue;
        }
        return hasErrors;
      },
      showRequiredError () {
        return `The ${this.name} field is required`;
      },
    },
  };
</script>

<style lang="scss">
  @import "../../../sass/variables";

  $mf-border-color : #999 !default;
  $mf-label-color : lighten($mf-border-color, 10%) !default;
  $mf-transition-speed : 0.28s !default;

  .select-form-group {
    .dropdown-toggle {
      input:not(.search) {
        color       : transparent;
        text-shadow : 0 0 0 #000;
        &.read-write {
          cursor : pointer;
        }
        @media print {
          color : inherit !important;
        }
      }
      input.search::placeholder {
        color      : transparent;
        transition : all $mf-transition-speed ease;
      }
      input.search:focus::placeholder {
        color : $mf-label-color;
      }
    }
    .dropdown-menu {
      padding : 0;
      .vuestic-scrollbar {
        height : $dropdown-item-height * 4;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-multi-select/VuesticMultiSelect.vue